export interface BmsData {
  sensorId: number;
  name?: string;
  description?: string;
  identifier?: string;
  externalIdentifier?: string;
  tpId: number;
  type?: string;
  spaceName?: string;
  objectId?: number;
  urn?: string;
  level?: string;
  floorId?: number;
  blockName?: string;
  blockId?: number;
  id?: number;
  typeWorkset?: string;
  typeName?: string;
  elementFamily?: string;
  department?: string;
  category?: string;
}
